module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/kv-home-970fc714bab02d9fdbefccf3658c0937.png";